import { Chat, Message } from '../../types';

export class StorageService {
    private static instance: StorageService;
    private readonly CHAT_HISTORY_KEY = 'chat_history';
    private readonly USER_STREAK_KEY = 'user_streak';
    private readonly LAST_VISIT_KEY = 'last_visit';
    private readonly USER_PREFERENCES_KEY = 'user_preferences';

    private constructor() {}

    static getInstance(): StorageService {
        if (!StorageService.instance) {
            StorageService.instance = new StorageService();
        }
        return StorageService.instance;
    }

    // Chat History
    getChatHistory(): Chat[] {
        try {
            const saved = localStorage.getItem(this.CHAT_HISTORY_KEY);
            return saved ? JSON.parse(saved) : [];
        } catch (error) {
            console.error('Error loading chat history:', error);
            return [];
        }
    }

    saveChatHistory(history: Chat[]): void {
        try {
            localStorage.setItem(this.CHAT_HISTORY_KEY, JSON.stringify(history));
        } catch (error) {
            console.error('Error saving chat history:', error);
        }
    }

    addChat(chat: Chat): void {
        const history = this.getChatHistory();
        history.unshift(chat);
        // Keep only last 50 chats
        this.saveChatHistory(history.slice(0, 50));
    }

    updateChat(chatId: string, updates: Partial<Chat>): void {
        const history = this.getChatHistory();
        const index = history.findIndex(c => c.id === chatId);
        if (index !== -1) {
            history[index] = { ...history[index], ...updates };
            this.saveChatHistory(history);
        }
    }

    deleteChat(chatId: string): void {
        const history = this.getChatHistory();
        const filtered = history.filter(c => c.id !== chatId);
        this.saveChatHistory(filtered);
    }

    // User Streak
    getUserStreak(): number {
        const streak = localStorage.getItem(this.USER_STREAK_KEY);
        return streak ? parseInt(streak, 10) : 0;
    }

    updateUserStreak(streak: number): void {
        localStorage.setItem(this.USER_STREAK_KEY, streak.toString());
    }

    // Last Visit
    getLastVisit(): string | null {
        return localStorage.getItem(this.LAST_VISIT_KEY);
    }

    updateLastVisit(date: string): void {
        localStorage.setItem(this.LAST_VISIT_KEY, date);
    }

    // Clear all data
    clearAll(): void {
        localStorage.clear();
    }
}